"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaPartnershipsVideo1Schema = void 0;
exports.MediaPartnershipsVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/media-partnerships-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MediaPartnershipsVideo1",
    "description": "This service is used whenever assets from the media partnerships Sparkle is used.",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "const": "rrn:content:ext:services:media-partnerships-video:1"
        },
        "attributes": {
            "type": "object",
            "properties": {
                "assetId": {
                    "type": "string",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                },
                "VIN": {
                    "type": "string",
                    "description": "The video identification number (VIN) of the video.",
                    "pattern": "^MI[0-9]+$"
                }
            },
            "required": [
                "assetId",
                "VIN"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9tZWRpYS1wYXJ0bmVyc2hpcHMtdmlkZW8vMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw2QkFBNkIsR0FBRztJQUMzQyxLQUFLLEVBQUUsNkZBQTZGO0lBQ3BHLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHlCQUF5QjtJQUNsQyxhQUFhLEVBQUUsbUZBQW1GO0lBQ2xHLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE9BQU8sRUFBRSxxREFBcUQ7U0FDL0Q7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixTQUFTLEVBQUUsbURBQW1EO2lCQUMvRDtnQkFDRCxLQUFLLEVBQUU7b0JBQ0wsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxxREFBcUQ7b0JBQ3BFLFNBQVMsRUFBRSxZQUFZO2lCQUN4QjthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFNBQVM7Z0JBQ1QsS0FBSzthQUNOO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=